import { useEffect } from 'react';
import getAppVersion from 'utility/getAppVersion';

const useLogAppVersion = () => {
	const version = getAppVersion({ prefix: true });

	useEffect(() => {
		// eslint-disable-next-line no-console
		console.log(
			`%cApp version: ${version}`,
			`padding: 4px; margin-top: 4px; color: white; background-color: black; border-radius: 4px; font-size: 14px;`,
		);
	}, [version]);
};

export default useLogAppVersion;
